import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ProjectDataApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectdata'
    }


    /**
     * 查询项目列表分页
     * @returns 
     */
    public getEntitiesPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET)
    }

    /**
     * 项目id查询项目分区列表
     * @param projectId 
     */
    public getListByProjectId(params){
        return this.send(params,"getListByProjectId",Methods.GET)
    }

    /**
     * 分页查询项目分区列表
     * @param current 
     * @param size 
     * @param projectdata 
     * @returns 
     */
    public getPageListByProjectId(current,size,projectId,subProjectName){
        return this.send({current:current,size:size,projectId:projectId,subProjectName:subProjectName},"getPageListByProjectId",Methods.GET)
    }

    /**
     * 保存到项目分区
     * @param param 
     */
    public saveProjectData(param){
        return this.send(param,"saveProjectData",Methods.POST)
    }

    /**
     * 删除项目分区
     * @param id 
     */
    public deleteProjectdata(id){
        return this.send({},"delete?ids="+id,Methods.POST)
    }
    /**
     * 查询共享项目分区接口
     * @param projectId 
     * @param id 
     */
    public getShareProjectDataList(projectId,id){
        return this.send({projectId:projectId,id:id},"getShareProjectDataList",Methods.GET)
    }
/**
 * 模糊分页查询子项目
 * @param current 
 * @param size 
 * @param subProjectName 
 */
    public getProjectDataPageList(current,size,subProjectName){
        return this.send({current:current,size:size,subProjectName:subProjectName},"getProjectDataPageList",Methods.GET)
    }
    /**
     * 查询所有的子项目
     */
    public getAllProjectDataList(){
        return this.send({},"getAllProjectDataList",Methods.GET)
    }
}